import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { RewardsAction } from '../types'

type WithdrawStep = 'form' | 'review'

interface UseWithdrawSheetHeaderProps {
  currentStep: WithdrawStep
  isRemoveAllocation: boolean
  handleSheetUpdate: (action: Omit<RewardsAction, 'onClose' | 'actionId'>) => void
  onReviewBack: () => void
  rewardsSheetAction?: RewardsAction
}

export const useWithdrawSheetHeaderUpdates = ({
  currentStep,
  isRemoveAllocation,
  handleSheetUpdate,
  onReviewBack,
  rewardsSheetAction,
}: UseWithdrawSheetHeaderProps) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (rewardsSheetAction) {
      if (currentStep === 'review') {
        handleSheetUpdate({
          header: t('rewards.withdraw.reviewHeader'),
          onBack: onReviewBack,
        })
      } else {
        handleSheetUpdate({
          header: isRemoveAllocation
            ? t('rewards.removeAllocation.header')
            : t('rewards.withdraw.header'),
          onBack: undefined,
        })
      }
    }
  }, [currentStep, isRemoveAllocation, t, handleSheetUpdate, rewardsSheetAction])
}
